const LOAD_DATA_MASTER_JOB_POSTING_TYPE           = 'LOAD_DATA_MASTER_JOB_POSTING_TYPE'
const LOAD_DATA_MASTER_JOB_POSTING_TYPE_SUCCESS   = 'LOAD_DATA_MASTER_JOB_POSTING_TYPE_SUCCESS'
const LOAD_DATA_MASTER_JOB_POSTING_TYPE_FAILED    = 'LOAD_DATA_MASTER_JOB_POSTING_TYPE_FAILED'
const UNMOUNT_DATA_MASTER_JOB_POSTING_TYPE        = 'UNMOUNT_DATA_MASTER_JOB_POSTING_TYPE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterJobPostingTypeReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_JOB_POSTING_TYPE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_JOB_POSTING_TYPE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_JOB_POSTING_TYPE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_JOB_POSTING_TYPE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterJobPostingTypeReducer;